import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Chip,
  Box,
  Button,
} from "@mui/material";

export default function ReviewEventDetails({
  state,
  addressConfirmed,
  onSubmit,
  canSubmit,
  busy,
}) {
  const method = state.fulfillment?.method || "pickup";
  const dateISO = state.fulfillment?.scheduledDate || "";
  const address = state.fulfillment?.address?.line1 || "";

  return (
    <Card variant="outlined" sx={{ borderRadius: 3, mb: 2 }}>
      <CardContent sx={{ p: 2.25 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: { xs: "flex-start", md: "center" },
            justifyContent: "space-between",
            gap: 2,
            flexDirection: { xs: "column", md: "row" },
          }}>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
              Event details
            </Typography>
            <Box sx={{ mt: 1, display: "flex", gap: 1, flexWrap: "wrap" }}>
              <Chip
                size="small"
                label={method === "delivery" ? "Delivery" : "Pickup"}
              />
              {state.fulfillment?.setupSelected && (
                <Chip size="small" label="Setup" color="default" />
              )}
              {dateISO && <Chip size="small" label={dateISO.slice(0, 10)} />}
              {address && <Chip size="small" label={address} />}

              {!addressConfirmed &&
                (method === "delivery" || state.fulfillment?.setupSelected) && (
                  <Chip
                    size="small"
                    color="warning"
                    label="Address required for delivery/setup"
                  />
                )}
            </Box>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}
